import {IntermediatePart} from "../../intermediatePart";

export default class TopCabinet extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'top_cabinet';
    this.partName = 'Top Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.top_cabinet";
    this.hasAdditionalParts = true;
    this.layerPriority = 1;
    this.allWallsCanBeApplied = true;
    this.canBeDisabled = true;
  }

  disabledClick() {
    const cabinetParent = this.getParent();
    if (cabinetParent.topHandle) {
      cabinetParent.topHandle.disabled = this.disabled;
    }
  }

}

